import translations from '../../config/translations/de'
import parse from './parse'

const translate = (key, params) => parse(translations[key], params)
export default translate
